export enum UIHeadingTracking {
    normal,
    wide,
    wider,
    widest
}